export const uploadFile = (uploadLink, file) =>
  fetch(uploadLink, {
    method: 'PUT',
    body: file,
  })
    .then((response) => [null, response])
    .catch((error) => [error, null]);
